<template>
  <vx-card>
    <vue-apex-charts :key="key" type="bar" :height="height" :options="extractedData.chartOptions" :series="extractedData.series"></vue-apex-charts>
  </vx-card>
</template>

<script>
export default {
  name: 'referrals-histogram-card',
  props: {
    data: Object,
    height: Number
  },
  data () {
    return {
      extractedData: null,
      key: 0
    };
  },
  watch: {
    data: {
      immediate: true,
      handler (value) {
        this.key++;
        const root = value.analysis.find(n => n.name === 'ROOT');
        const allTime = root.nested.find(n => n.name === 'ALL_TIME');
        const status = allTime.nested.find(n => n.name === 'STATUS');
        const referrals = allTime.nested.find(n => n.name === 'REFERRALS');

        const series = [];
        status.buckets.forEach(st => {
          const serie = {
            name: this.$t(`reports.referrals.status.values.${st.key}`),
            data: []
          };

          referrals.buckets.map(o => {
            const statusFilter = o.nested.find(n => n.name === 'STATUS');
            const bucket = statusFilter.buckets.find(b => b.key === st.key);
            serie.data.push({
              x: Number.parseFloat(o.key),
              y: bucket ? bucket.count : 0
            });
          });

          series.push(serie);
        });

        this.extractedData = {
          series,
          chartOptions: {
            legend:{
              showForSingleSeries: true
            },
            chart: {
              type: 'bar',
              stacked: true,
              toolbar: {
                show: false
              },
              zoom: {
                enabled: false
              }
            },
            colors: [
              (value) => {
                switch (series[value.seriesIndex].name) {
                case this.$t('reports.referrals.status.values.ACCEPTED'):
                  return '#19aef6';
                case this.$t('reports.referrals.status.values.LINK_CLICKED'):
                  return '#039c88';
                case this.$t('reports.referrals.status.values.OPENED'):
                  return '#27ae60';
                case this.$t('reports.referrals.status.values.SENT'):
                  return '#67A88A';
                case this.$t('reports.referrals.status.values.EXPIRED'):
                  return '#ffb729';
                case this.$t('reports.referrals.status.values.CANCELLED'):
                  return '#cccccc';
                case this.$t('reports.referrals.status.values.ERRORED'):
                  return '#eb4d55';
                default:
                  return 'red';
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                borderRadius: 0,
                columnWidth: '50%'
              }
            },
            xaxis: {
              type: 'datetime',
              labels: {
                datetimeFormatter: {
                  year: 'yyyy',
                  month: 'MMM yyyy',
                  day: 'dd MMM',
                  hour: 'HH:mm'
                }
              }
            },
            fill: {
              opacity: 1
            }
          }
        };
      }
    }
  }
};
</script>

<style scoped>

</style>
